import React from 'react';

// eslint-disable-next-line
function Button({ children, className, ...rest }) {
  const button = React.createRef();
  return (
    <button type="button" className={`Select--btn btn btn-default ${className}`} {...rest}>
      {children}
    </button>
  );
}

export default Button;
